import React, { useState } from 'react';
import { i18nIntl, validateEmail } from '../../lib/ep.js';

import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';

import FloatingLayer from '../builder/FloatingLayer.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import Input from '../builder/Input.js';
import SectionTitle from '../builder/SectionTitle.js';
import SectionSubtitle from '../builder/SectionSubtitle';

const ParticipateFormEdit = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const promotion = props?.promotion?.Promotion ?? false;
	const props_user = props?.user?.User ?? false;

	const [ user, setUser ] = useState(props_user);
	const [ errors, setErrors ] = useState({});
	const [ submitting, setSubmitting ] = useState(false);
	
	if(promotion === false) return null;
	
	const hide_name = promotion?.hide_name ?? false;
	let throttleChange;

	const changeUser = (k, v) => {
		validate(k, v);
		setUser({ ...user, [k]:v });
	};

	const submit = (cb) => {
		let _errors = {};
		if(promotion.need_nickname == '1'){
			let data = {nickname:user.nickname,skip_login_id:user.login_id,id:promotion.id,};
			$.post('/utils/nickname/', data, (result) => {
				if(!result.status){
					_errors['nickname'] = i18n("This nickname is already registered");
					setErrors(_errors);
				}else{
					setSubmitting(true);
					if(props.onSubmit != undefined) props.onSubmit(user, cb);
				}
			},'JSON');
		}else{
			setSubmitting(true);
			if(props.onSubmit != undefined) props.onSubmit(user, cb);
		}
	};

	const validateNickname = (value) => {
		const invalid_chars = [',', ':', '"', "'", ';', '\\', '/', '='];
		const has_invalid = new RegExp('[\\' + invalid_chars.join("\\") + ']');
	
		var valid = true;
		var error = false;
		if(value != '') {
			var length_str = value.trim().length;
			if(length_str < 3 || length_str > 30) {
				valid = false;
				error = "size";
			} else if(has_invalid.test(value)) {
				valid = false;
				error = "chars";
			}
		}
		return {status:valid?1:0,error:error};
	}

	const validate = (k, v) =>  {
		const i18n = (m, c) => i18nIntl(m, props.intl, c);
		if(typeof v === 'string') v = v.trim();
		let is_mandatory = true;
		let has_error = false;
		let _errors = {};
		setErrors({});
		// all fields, except those that have "mandatory = 0" (custom fields), are mandatory:
		const typeof_v = typeof v;
		if(is_mandatory && (typeof_v === 'string' && v.length < 1 || typeof_v === 'boolean' && !v) && !has_error) {
			has_error = i18n("This field cannot be left empty");
		}
		
		switch(k) {
			case 'nickname':
				if(v != ''){
					let nickname_result = validateNickname(v);
					if(nickname_result.error) {
						has_error = (nickname_result.error == 'size') ? i18n("The nickname has to have at least three characters.") : i18n("The nickname contains invalid characters.");
					}
				}
				break;
		}

		if(has_error !== false) {
			_errors[k] = has_error;
			setErrors(_errors);
		}
	}

	return (
		<FloatingLayer
			_class={{size:'small'}}
			backButton={props.backButton}
		>
			<div>
				<SectionTitle>Edit user main information</SectionTitle>

				<SectionSubtitle autotranslate={false}>{props_user.name}</SectionSubtitle>

				{(!hide_name || true) && (
					<Model
						model={user}
						change={changeUser}
						errors={errors}
						classname="gui_equal_columns gui_padded_children_low"
					>
						<Input
							name='first_name'
						>First name</Input>

						<Input
							name='last_name'
						>Last name</Input>
					</Model>
				)}

				{(promotion.need_nickname == '1') && (
					<Model
						model={user}
						change={changeUser}
						errors={errors}
					>
						<Input
							name='nickname'
							_class={{size:70}}
						>Nickname</Input>
					</Model>
				)}

				<ButtonCollection in_floating={true}>
					<SaveButton
						disabled={(submitting) ? true : false}
						onClick={(e, cb) => submit(cb)}
						autotranslate={false}
					>Save changes</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
}

export default ParticipateFormEdit;